module.exports = __webpack_public_path__ + "media/images/i3LEARNHUB-Packshot-Learnhubflow-9add4ccf3a1d989ab4c1dcfea5ac3e81.png";